import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PartnerCodeService } from './services/partner-code.service';
import { PartnerCodeStateService } from './services/partner-code-state.service';
import { TranslateModule } from '@ngx-translate/core';
import { PartnerCodeScanComponent } from './components/partner-code-scan/partner-code-scan.component';
import { PartnerCodeLoginComponent } from './components/partner-code-login/partner-code-login.component';
import { GeneralModule } from '../general/general.module';
import { LoginModule } from '../login/login.module';
import { PartnerModule } from '../partner/partner.module';
import { ChoicePartnerTypeComponent } from './components/choice-partner-type/choice-partner-type.component';
import { PartnerCodeProfileInfoGuard } from './guards/partner-code-profile-info.guard';
import { PartnerCodeTransactionListComponent } from './components/partner-code-profile-info/partner-code-transaction-list/partner-code-transaction-list.component';
import { PartnerCodeProfileInfoComponent } from './components/partner-code-profile-info/partner-code-profile-info.component';
import { RouterModule, Routes } from '@angular/router';
import { PartnerCodeCardInformationComponent } from './components/partner-code-card-information/partner-code-card-information.component';
import { PartnerCodePageComponent } from './pages/partner-code-page/partner-code-page.component';
import { PartnerCodePageGuard } from './guards/partner-code-page.guard';
import { PartnerCodeScanGuard } from './guards/partner-code-scan.guard';
import { PartnerCodeInfoStepService } from './services/partner-code-info-step.service';
import { SmartCardModule } from '../smart-card/smart-card.module';

const routes: Routes = [
  {
    path: 'partner-code',
    component: PartnerCodePageComponent,
    canActivate: [PartnerCodePageGuard],
    children: [{
      path: '',
      children: [
        {
          path: 'scan',
          canActivate: [PartnerCodeScanGuard],
          component: PartnerCodeCardInformationComponent,
          data: {
            title: ['Scan'],
            activateMode: false,
          },
        },
        {
          path: 'transactions',
          canActivate: [PartnerCodeProfileInfoGuard],
          component: PartnerCodeProfileInfoComponent,
          data: { title: 'Profile Information' },
        },
        {
          path: '**',
          redirectTo: 'partner-code/scan',
          pathMatch: 'full'
        },
      ]
    }
    ]
  },
];

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    GeneralModule,
    LoginModule,
    PartnerModule,
    SmartCardModule,
    RouterModule.forChild(routes),
  ],
  exports: [
    PartnerCodeScanComponent,
    PartnerCodeLoginComponent,
  ],
  declarations: [
    PartnerCodeScanComponent,
    PartnerCodeLoginComponent,
    ChoicePartnerTypeComponent,
    PartnerCodeCardInformationComponent,
    PartnerCodeProfileInfoComponent,
    PartnerCodeTransactionListComponent,
    PartnerCodePageComponent,
  ],
  providers: [
    PartnerCodeInfoStepService,
    PartnerCodeService,
    PartnerCodeStateService,
    PartnerCodeProfileInfoGuard,
    PartnerCodePageGuard,
    PartnerCodeScanGuard,
  ],
  entryComponents: [
  ]
})
export class PartnerCodeModule { }
